import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';

import * as actions from './Actions.js';

export class EmpenhoDetalheMovimentacao extends Component {
  static propTypes = {
    movimentacao: PropTypes.object.isRequired
  };

  renderItens = data => {
    let key =
      data.get('tipoLancamento') +
      '_' +
      data.get('noLiquidacao') +
      '_' +
      data.get('exercicioLiquidacao') +
      '_' +
      data.get('noPagamento') +
      '_' +
      data.get('exercicioPagamento') +
      '_' +
      data.get('nroDocumento');

    return (
      <tr key={key} data={data}>
        <td>{DateUtils.formatDateTimeShort(data.get('data'))}</td>
        <td>{data.get('descricaoTipoLancamento')}</td>
        <td>{data.get('nroDocumento')}</td>
        <td className="right">
          <NumberFormatter value={data.get('valor')} />
        </td>
        <td className="right">
          <NumberFormatter value={data.get('valorALiquidar')} />
        </td>
        <td className="right">
          <NumberFormatter value={data.get('valorAPagar')} />
        </td>
      </tr>
    );
  };

  render() {
    const { movimentacao } = this.props;

    return (
      <div className="panel-table-outer">
        <table className="panel-table striped fancy">
          <TableHeader empty={movimentacao.isEmpty()}>
            <tr>
              <th>Data</th>
              <th>Descrição</th>
              <th>Nº Documento</th>
              <th className="right">Valor</th>
              <th className="right">Valor a Liquidar</th>
              <th className="right">Valor a Pagar</th>
            </tr>
          </TableHeader>
          <tbody>{movimentacao.map(this.renderItens)}</tbody>
        </table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    movimentacao: state.empenhos.get('movimentacao')
  };
}

const allActions = {
  ...actions
};

export default connect(mapStateToProps, allActions)(EmpenhoDetalheMovimentacao);
